import { render, staticRenderFns } from "./historyListNew.vue?vue&type=template&id=534816e0&scoped=true&"
import script from "./historyListNew.vue?vue&type=script&lang=js&"
export * from "./historyListNew.vue?vue&type=script&lang=js&"
import style0 from "./historyListNew.vue?vue&type=style&index=0&id=534816e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534816e0",
  null
  
)

export default component.exports